<fhm-search-page [gridData]="gridData" [showLink]="false" [showAdd]="true" [type]="'partner-search'" [columns]="['name']"
                 (addNew)="addNew()" [showDelete]="false"></fhm-search-page>
